import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateBox, LoadPanel, Popup, ScrollView, TextArea } from "devextreme-react";
import BaseActionCell, { BaseActionCellProps } from "../GridCells/BaseActionCell";
import { faFaceThinking } from "@fortawesome/pro-light-svg-icons";
import { faFaceThinking as faSolidFaceThinking } from "@fortawesome/pro-solid-svg-icons";
import FindAnArtistService from "../../services/FindAnArtistService";
import { AxiosResponse } from "axios";
import { DateBoxOnValueChangedEvent, TextBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import notify from "devextreme/ui/notify";

class GigRequestOptionsSentCell extends BaseActionCell {
    service: FindAnArtistService;
    constructor(props: BaseActionCellProps) {
        super(props);
        this.service = new FindAnArtistService();
    }
    closeOptionsSentBox = () => {
        this.setState({
            onOptionsSentConfirm: false,
        });
    };

    onClickFaceBtn = () => {
        this.setState({
            onOptionsSentConfirm: true,
            errorMessage: []
        });
    };

    removeOptionsSentClick = () => {
        this.showLoadPanel();
        let requestStatusId = this.props.data.data.previousRequestStatus?.id.toString();
        let previousRequestStatusId = "";
        let submitRequest = this.findAnArtistUtils.mapOptionsSentRequest(this.props.data.data.id, false, null, this.state.internalComments, this.props.data.data.featured, this.props.data.data.reoccurrence, this.props.data.data.serviceTypeLookUp.id.toString(), this.props.data.data.serviceSubTypeLookUp.id.toString(), this.props.data.data.clientBusinessEntity.id.toString(), requestStatusId, previousRequestStatusId);
        this.service.updateArtistRequest(this.props.data.data.id, submitRequest)
            .then(this.handlePostOptionsSentSuccess)
            .catch((error) => {
                let respMessage: string = "Re Confirmed failed with response: " + JSON.stringify(error);
                this.hideLoadPanel();
                notify({ message: "Sorry! Option Sent failed", width: 300, shading: true }, 'error', 600);
                if (!this.Service.traceAsErrorToAppInsights(respMessage)) {
                    console.error(respMessage);
                }
            });
    }

    handlePostOptionsSentSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            loadPanelVisible: false,
            gridOptionsSentDate: response.data.data.optionsSentDateTime,
            gridOptionsConfirmStatus: response.data.data.isOptionsSent
        });
        this.closeOptionsSentBox();
        this.props.getRequestGridStatusUpdate ? this.props.getRequestGridStatusUpdate(true) : null;
        notify({ message: "Thank you", width: 300, shading: true }, 'success', 600);
    };


    handleOptionsSentOnClick = () => {
        this.showLoadPanel();
        let requestStatusId = "23";
        let previousRequestStatusId = "";
        if(this.props.data.data.requestStatus?.id.toString() !== requestStatusId){
            previousRequestStatusId = this.props.data.data.requestStatus?.id.toString();
        }
        let submitRequest = this.findAnArtistUtils.mapOptionsSentRequest(this.props.data.data.id, true, this.state.optionsSentConfirmDate, this.state.internalComments, this.props.data.data.featured, this.props.data.data.reoccurrence, this.props.data.data.serviceTypeLookUp.id.toString(), this.props.data.data.serviceSubTypeLookUp.id.toString(), this.props.data.data.clientBusinessEntity.id.toString(), requestStatusId, previousRequestStatusId);
        this.service.updateArtistRequest(this.props.data.data.id, submitRequest)
            .then(this.handlePostOptionsSentSuccess)
            .catch((error) => {
                if (error.response && error.response.data.error) {
                    this.setState({
                        errorMessage: JSON.parse(JSON.stringify(error.response.data.error))
                    });
                }
                else {
                    let respMessage: string = "Options Sent failed with response: " + JSON.stringify(error);
                    notify({ message: "Sorry! Option Sent failed", width: 300, shading: true }, 'error', 600);
                    if (!this.Service.traceAsErrorToAppInsights(respMessage)) {
                        console.error(respMessage);
                    }
                }
                this.hideLoadPanel();
            });
    }

    handleChangeInternalComment = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState({
            internalComments: dxValueChange.value
        });
    };

    handleChangeOptionsSentDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        this.setState(
            {
                optionsSentConfirmDate: dxValueChange.value
            }
        );
    };

    render() {
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        message="Please wait..."
                        visible={this.state.loadPanelVisible}
                    />
                    { this.props.data.data.requestStatus?.id == 30 ?
                            <button className={"disabled icon-btn"}>
                                {this.state.gridOptionsConfirmStatus ?
                                    <span><FontAwesomeIcon icon={faSolidFaceThinking} /></span>
                                    : <span><FontAwesomeIcon icon={faFaceThinking} /></span>}
                            </button> :
                            <button className={"btn icon-btn"} onClick={this.onClickFaceBtn}>
                                {this.state.gridOptionsConfirmStatus ?
                                    <span><FontAwesomeIcon icon={faSolidFaceThinking} /></span>
                                    : <span><FontAwesomeIcon icon={faFaceThinking} /></span>}
                            </button>
                    }
                    {this.state.gridOptionsSentDate}
                </div>
                <Popup
                    wrapperAttr={{
                        class: "pending-request-panel__raise-query-pop-up",
                    }}
                    visible={this.state.onOptionsSentConfirm}
                    onHiding={this.closeOptionsSentBox}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Please Confirm date and update comment (as reqd.)"
                    maxWidth="600px"
                    height="auto"
                >
                    <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                    <ScrollView width="100%" height="100%">
                        <div className="pending-request-panel__raise-query">
                            <div className="pending-request-panel__query-box">
                                {this.state.errorMessage && this.state.errorMessage.length > 0 && this.state.errorMessage != null ? (
                                    <span className="unscheduled-shift">
                                        <ul>
                                            {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                                return (
                                                    <li key={uniqueKey}>
                                                        {item.columnName}: {item.errorMessage}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </span>
                                ) : null}
                                <div className="card-form__subheading ">Internal Comments
                                    <sup className="card-form__mandatory-symbol">*</sup></div>
                                <TextArea
                                    onValueChanged={this.handleChangeInternalComment}
                                    value={this.state.internalComments}
                                    height="50%"
                                />
                                <div className="card-form__subheading mt-4">
                                    Date Confirmed?
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <DateBox
                                        onValueChanged={this.handleChangeOptionsSentDate}
                                        value={
                                            this.state.optionsSentConfirmDate
                                                ? this.state.optionsSentConfirmDate
                                                : undefined
                                        }
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                    ></DateBox></div>
                                <div className="row">
                                    <div className={this.state.gridOptionsConfirmStatus ? "col-12 col-lg-6" : "col-12 col-lg-612"} >
                                        <button className="btn btn-primary btn--large" onClick={this.handleOptionsSentOnClick}>
                                            Confirm Options Sent
                                        </button>
                                    </div>
                                    <div className="col-12 col-lg-6" hidden={!this.state.gridOptionsConfirmStatus}>
                                        <button className="btn btn--ghost btn--ghost--teal btn--large" onClick={this.removeOptionsSentClick}>
                                            Remove Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
            </>
        );
    }
}
export default GigRequestOptionsSentCell;